import {useEffect,useState} from 'react';
/** Stripe checkout return never means a Gift Card was paid or emailed. */
export function StaffGiftCardPaymentReturn({customerId}:{customerId:string}){
  const params=new URLSearchParams(window.location.search);
  const giftDraft=params.get('gift_draft')??'';
  const location=params.get('location')??'';
  const outcome=params.get('staffGiftCheckout');
  const valid=Boolean(outcome)&&
    /^[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i.test(giftDraft)&&
    /^[A-Z0-9_-]{2,64}$/.test(location);
  const [status,setStatus]=useState('');
  useEffect(()=>{
    if(!valid||!customerId)return;
    let active=true;
    const poll=async()=>{
      try{
        const response=await fetch('/api/v1/staff/sales/stripe/test-gift-drafts/'+
          encodeURIComponent(giftDraft)+'?'+new URLSearchParams({
            customerId,location,
          }),{credentials:'same-origin',cache:'no-store'});
        const body=await response.json() as {ok:boolean;data?:{
          status:string;paid:boolean;voucherCount:number}};
        if(!response.ok||!body.ok||!body.data)
          throw Error('Gift Card payment record unavailable.');
        if(active)setStatus(body.data.paid&&
          body.data.status==='ISSUED_PENDING_DELIVERY'
          ?'Stripe TEST payment verified. '+body.data.voucherCount+
            ' Gift Card voucher(s) issued. Email delivery follows the saved setup.'
          :body.data.paid
            ?'Stripe TEST payment verified. Gift Card issuance is processing.'
            :'Gift Card payment is not yet verified.');
      }catch{if(active)setStatus('Gift Card TEST payment verification unavailable.');}
    };
    void poll();const timer=window.setInterval(()=>void poll(),3000);
    return ()=>{active=false;window.clearInterval(timer);};
  },[valid,customerId,giftDraft,location]);
  if(!valid)return null;
  return <section className="ecfs-sale-receipt" role="region"
    aria-label="Staff Gift Card Stripe TEST result">
    <h3>Gift Card Payment</h3>
    <p role="status">{status||'Checking signed Stripe TEST Gift Card payment…'}</p>
    <small>Gift draft: {giftDraft}</small>
  </section>;
}
